<template>
  <div class="productbox">
    <van-action-sheet v-model:show="store.dislog.product" title="请选择需要咨询的内容">
      <div class="content">
      <div class="nobg" v-if="comments.length==0 && isLoad">
        <div class="thtit">暂无数据</div>
      </div>
        <ul>
          <li v-for="i in comments">
            <img :src="i.imagePath" />
            <div class="rt">
              <div class="name">{{ i.skuName }}</div>
              <div class="bot">
                <div class="lf">
                  <!-- <span class="price">12.15</span>起+16.9品牌基金
                  <span class="jd">140.00京东价</span> -->
                </div>
                <div class="nsend" @click="send(i)">发送</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-action-sheet>
  </div>
</template>
<script setup>
  import { ref } from 'vue'
  import { useSocket } from "@/stores/index";
  import  { useWork } from '@/stores/work'
  const store = useSocket()
  const work=useWork()
  import { getQueryString } from '@/assets/js/index'
  import {getOrder} from '@/api/index';
  import { sendType } from '@/assets/js/index'
  const comments=ref([])
  const isLoad=ref(false)

  const init=async()=>{
    isLoad.value=false;
    const supplierCode=store.group.supplierCode ||  getQueryString('code')
    const order=await getOrder({
      wxappId:work.auth.wxappId,
      supplierCode:supplierCode.toUpperCase(),
      goodsId:getQueryString('goods_id')
    })
    comments.value=order || []
    isLoad.value=true
  }
  const send=(data)=>{
    const newData=Object.assign({
      type:10,
    },data)
    console.log(newData)
    store.sendMess({
      content:JSON.stringify(newData),
      groupId: store.group.id,
      type: sendType.PRODUCT
    })
    store.seeOP('product',false)
  }
  defineExpose({
    init
  });
</script>
<style lang="scss" scoped>
  .nobg{
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .thtit{
      background: url('@/assets/images/nobg.png') no-repeat center top;
      background-size: 81px auto;
      font-weight: 400;
      font-size: 15px;
      color: #333;
      text-align: center;
      padding-top:86px;
    }
  }
  .productbox {
    .content {
      li {
        height: 88px;
        background: #FFF;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 14px 12px;
        margin-bottom: 12px;
        display: flex;
        img {
          width: 58px;
          height: 58px;
          border-radius: 4px;
        }
        .rt {
          padding-left: 7px;
          width: calc(100% - 58px);
          box-sizing: border-box;
          flex: 3;
          .name {
            font-size: 14px;
            color: #222;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .nums {
            font-weight: 400;
            font-size: 13px;
            color: #A2A2A2;
            line-height: 18px;
          }
          .bot {
            display: flex;
            justify-content: space-between;
            height: 24px;
            align-items: flex-end;
            margin-top: 14px;

            .lf {
              font-size: 10px;
              color: #EF413C;
              line-height: 14px;
              display: flex;
              align-items: baseline;
              flex-wrap: wrap;
              .price {
                font-size: 16px;
                color: #EF413C;
                line-height: 21px;
              }
              .jd{
                font-weight: 400;
                font-size: 10px;
                color: #999999;
                line-height: 11px;
                text-decoration-line: line-through;
              }
            }
            .nsend {
              width: 50px;
              line-height: 24px;
              background: #FF7D38;
              border-radius: 12px;
              text-align: center;
              font-weight: 400;
              font-size: 13px;
              color: #FFF;
            }
          }
        }
      }
    }
  }
</style>
